import React, { FC } from 'react'

import Layout, { LayoutProps } from '../../layouts/Layout'
import { ResetPasswordFormProps } from '../../components/forms/ResetPasswordForm'
import { ActionButtonProps } from '../../components/ActionButton'

import * as SC from './styled'

export type ResetPasswordTemplateProps = {
  className?: string
  layoutProps?: LayoutProps
  title?: string
  form: ResetPasswordFormProps
  successMessage?: string
  backButton?: ActionButtonProps
}

const ResetPasswordTemplate: FC<ResetPasswordTemplateProps> = (props) => {
  const { title, layoutProps, form, successMessage, backButton } = props
  return (
    <Layout {...layoutProps}>
      <SC.Content>
        <SC.Box>
          {form.submitButton.isSuccess ? (
            <SC.SuccessMessageContainer>
              <SC.SuccessMessage>{successMessage}</SC.SuccessMessage>
              {backButton && <SC.BackButton {...backButton} />}
            </SC.SuccessMessageContainer>
          ) : (
            <>
              <SC.Title>{title}</SC.Title>
              <SC.Form {...form} />
            </>
          )}
        </SC.Box>
      </SC.Content>
    </Layout>
  )
}

export default ResetPasswordTemplate
